export default __webpack_public_path__ + "e79f1a237ceb39400a1b9cc21cf576fd.svg";